/**
 * Barra di avanzamento invio newsletter (RF-04 / §8.6.3).
 * Mostrata quando la newsletter è in stato SENDING; i valori arrivano da useSendProgress.
 */
import PropTypes from 'prop-types';
import { Card, CardContent, LinearProgress, Stack, Typography } from '@mui/material';

/**
 * @param {{ percent?: number, sent?: number, included?: number }} props
 */
export function SendProgressBar({ percent, sent, included }) {
  const value = Math.min(100, Math.max(0, Number(percent ?? 0)));

  return (
    <Card>
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
            Invio in corso…
          </Typography>
          <Typography variant="body2" sx={{ color: '#637381' }}>
            {(sent ?? 0)}
            {included != null ? ` / ${included}` : ''} · {Math.round(value)}%
          </Typography>
        </Stack>
        <LinearProgress variant="determinate" color="primary" value={value} sx={{ height: 8, borderRadius: 4 }} />
      </CardContent>
    </Card>
  );
}

SendProgressBar.propTypes = {
  percent: PropTypes.number,
  sent: PropTypes.number,
  included: PropTypes.number,
};

export default SendProgressBar;
